// Who may do what on a program's deliverables (D111). ryugu gates each write
// on a verb AND an area on the program's scope chain, so the UI mirrors both
// from the same resolve the page already makes:
//
//   - write:   `update` + `area:execution` (submit, move, propose, approve, rules, teams)
//   - create:  `create` + `area:execution` (new deliverable, team, SOW)
//   - verdict: `update` + `area:execution.verdict` (Record review), granted apart
//              from doing the work, so `write` alone never shows it;
//   - settings: `update` + `area:programs`.
//
// Fail-closed: while the projection loads, every flag is false, so a write
// control never flashes on for a viewer who cannot use it.
import { programRef } from '../../../lib/access/types';
import { useView } from '../../../lib/access/useView';
export function useCmAccess(programId) {
    const v = useView(programRef(programId), {
        enabled: !!programId
    });
    const area = (a)=>v.granted(a);
    return {
        isLoading: v.isLoading,
        canRead: v.viewMode !== 'no_view',
        canWrite: area('update') && area('area:execution'),
        canCreate: area('create') && area('area:execution'),
        canVerdict: area('update') && area('area:execution.verdict'),
        canSettings: area('update') && area('area:programs')
    };
}
